'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _l10n = require('../../../common/l10n');

var _l10n2 = _interopRequireDefault(_l10n);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var _this = this;

    var _props = this.props,
        children = _props.children,
        showArrows = _props.showArrows,
        showNavigation = _props.showNavigation,
        showCounter = _props.showCounter,
        _state = this.state,
        active = _state.active,
        appearDirection = _state.appearDirection,
        prevActive = _state.prevActive,
        slideHeight = _state.slideHeight,
        classList = this.compileStyle(_index2.default),
        bullets = null,
        prevArrow = null,
        nextArrow = null,
        leftSlide = null,
        rightSlide = null,
        slideClass = null,
        counter = null;


    children = _react2.default.Children.toArray(children);

    if (showArrows) {
        prevArrow = _react2.default.createElement(
            'div',
            { className: classList.navigationLeft, onClick: function onClick(e) {
                    return _this.navigate(-1);
                } },
            _react2.default.createElement('div', { className: classList.navigationImgLeft })
        );
        nextArrow = _react2.default.createElement(
            'div',
            { className: classList.navigationRight, onClick: function onClick(e) {
                    return _this.navigate(1);
                } },
            _react2.default.createElement('div', { className: classList.navigationImgRight })
        );
    }

    if (showNavigation) {
        bullets = _react2.default.createElement(
            'div',
            { className: classList.navigationWrapper },
            prevArrow,
            children.map(function (child, i) {
                return _react2.default.createElement('div', {
                    key: i,
                    className: classList.bullet + ' ' + (active === i ? 'active' : ''),
                    onClick: function onClick(e) {
                        return _this.toSlide(i);
                    }
                });
            }),
            nextArrow
        );
    }

    if (showCounter) {
        var current = active + 1,
            total = children.length,
            text = _l10n2.default.translate('SLIDER_COUNTER_KEY');

        counter = _react2.default.createElement(
            'div',
            { className: classList.counter },
            current,
            ' ',
            text,
            ' ',
            total
        );
    }

    if (active !== prevActive) {
        if (appearDirection < 0) {
            slideClass = classList.animatingToRight;
            rightSlide = _react2.default.createElement(
                'div',
                { key: prevActive, className: classList.slideWrapper + ' ' + classList.animatingToRight },
                children[prevActive]
            );
        } else if (appearDirection > 0) {
            slideClass = classList.animatingToLeft;
            leftSlide = _react2.default.createElement(
                'div',
                { key: prevActive, className: classList.slideWrapper + ' ' + classList.animatingToLeft },
                children[prevActive]
            );
        }
    }

    return _react2.default.createElement(
        'div',
        { className: classList.root },
        _react2.default.createElement(
            'div',
            { className: classList.contentWrapper },
            _react2.default.createElement(
                'div',
                {
                    className: classList.wrapper,
                    style: { height: slideHeight }
                },
                leftSlide,
                _react2.default.createElement(
                    'div',
                    {
                        key: active,
                        className: classList.slideWrapper + ' ' + (slideClass || ''),
                        onAnimationEnd: this.handleAnimationEnd
                    },
                    children[active]
                ),
                rightSlide
            ),
            counter
        ),
        bullets
    );
}